import LookupUtil from "@my-dld/utils/LookupUtil";
import ReactGA from "react-ga4";
import { setUtils } from "@10x/bcs/dist/utils";
import { httpGet, httpPost } from "@eres/rest";
import { BcsConfig } from "../bcsConfig";


export function Configure() {
	if ( window.apiConfig2 && window.apiConfig2.googleAnalyticsId )
		ReactGA.initialize( window.apiConfig2.googleAnalyticsId);
	LookupUtil.initCache();
	configureBCS();
}

function configureBCS() {
	setUtils( {
		httpUtils: {
			httpPost: httpPost,
			httpGet: httpGet,
		},
		config: {
			baseUrl: () => {
				return BcsConfig.api().endPoint();
			},
		},
	} );
}

export const APP_ID = 1000;
